<script lang="ts">
	import {uqn} from './stores.js';
	import check from './check_random/check';
	import Textfield, {Input, Textarea} from '@smui/textfield';
	import Button, {Label, Icon} from '@smui/button';
	import Dialog, {Title, Content, Actions} from '@smui/dialog';
	//import Slider from '@smui/slider';
	import Slider from './slider';
	import FormField from '@smui/form-field';
	import Katex from './Katex.svelte';
	import QnPreview from './QnPreview.svelte';
	import uqnSplit from './functions/uqnSplit';
	import uqnJoin from './functions/uqnJoin';
	import RadioGroup from './RadioGroup.svelte';
	import SliderNonZero from './SliderNonZero.svelte';
	import random from './check_random/random';
	import signAssign from './functions/signAssign';
	import signUnassign from './functions/signUnassign.js';
	//import getRandomInt from './functions/getRandomInt';
	//import signAssign from './functions/signAssign';
	//import signUnassign from './functions/signUnassign';

	let simpleDialog;
	
	let aSlide: number;
	let bSlide: number;
	let cSlide: number;
	let aSlideNeg: number;
	let bSlideNeg: number;
	let cSlideNeg: number;
	let _;
	let bSpecial: number;
	
	// initialize
	let type = $uqn.toString()[0];
	let intType = $uqn.toString()[1];
	let uqnInput = $uqn;

	// reactive
	$: _ = updateFromType(type);
	$: _ = updateFromIntType(intType);
	$: _ = updateFromUQN($uqn);
	$: _ = updateSlider(aSlide,bSlide,cSlide);
	$: _ = updateSliderNeg(aSlideNeg,bSlideNeg,cSlideNeg);

	let options = [
		{value: "1", label: "\\displaystyle \\frac{\\mathrm{d}y}{\\mathrm{d}x} = f(x)", katex: true},
		{value: "2", label: "\\displaystyle \\frac{\\mathrm{d}y}{\\mathrm{d}x} = f(y)", katex: true},
		{value: "3", label: "\\displaystyle \\frac{\\mathrm{d}^2y}{\\mathrm{d}x^2} = f(x)", katex: true}
	]
	let options1 = [
		{value: "0", label: "\\displaystyle \\frac{b}{x^2+a^2}", katex: true},
		{value: "1", label: "\\displaystyle \\frac{b}{x^2-a^2}", katex: true},
		{value: "2", label: "\\displaystyle \\frac{bx}{x^2+a^2}", katex: true},
		{value: "3", label: "\\displaystyle \\frac{bx}{x^2-a^2}", katex: true},
		{value: "4", label: "\\displaystyle \\frac{1}{x^2+ax+b}", katex: true},
		{value: "5", label: "\\displaystyle \\cos^2 ax", katex: true},
		{value: "6", label: "\\displaystyle \\sin^2 ax", katex: true}
	]
	let options2 = [
		{value: "0", label: "a-by", katex: true},
		{value: "1", label: "\\sqrt{a+by}", katex: true},
		{value: "2", label: "(a+by)^{\\frac{2}{3}}", katex: true},
		{value: "3", label: "a^2+b^2y^2", katex: true},
		{value: "4", label: "a^2-b^2y^2", katex: true},
		{value: "5", label: "-b-ay-y^2", katex: true},
		{value: "6", label: "e^{ay}", katex: true}
	]
	let options3 = [
		{value: "0", label: "a", katex: true},
		{value: "1", label: "a+bx", katex: true},
		{value: "2", label: "e^{ax}", katex: true},
		{value: "3", label: "\\cos ax", katex: true},
		{value: "4", label: "\\sin ax", katex: true}
	]

	function updateFromType(t:string){
		if (t!=$uqn.toString()[0]){
			uqnInput = random(Number(t));
			uqn.set(uqnInput);
			intType = uqnInput.toString()[1];
		}
	}
	
	function updateFromIntType(i:string){
		if (i!=$uqn.toString()[1]){
			uqnInput = random(Number(type),Number(i));
			uqn.set(uqnInput);
		}
	}
	
	function updateFromUQN(u:number){
		uqnInput = u;
		let [t,i,a,b,c,s] = uqnSplit(u);
		type = t.toString();
		intType = i.toString();
		if (t==1){
			cSlide = c;
			if (i==4){ // complete squre
				[a,b] = signAssign(s,a,b);
				aSlideNeg = a;
				bSlideNeg = b;
			} else{
				aSlide = a;
				bSlide = b;
			}
		} else if (t==2){
			cSlide = c;	
			if (i==6 || i==3 || i==4 || i==0){
				aSlide = a;
				bSlide = b;
			} else{
				aSlideNeg = a;
				bSlideNeg = b;
			}
		} else{
			[a,b,c] = signAssign(s,a,b,c);
			aSlideNeg = a;
			bSlideNeg = b;
			cSlideNeg = c;
		}
	}

	function updateSlider(a1:number,b1:number,c1:number){
		let [t,i,a,b,c,s] = uqnSplit($uqn);
		if (t==1){
			if (c1 != c){ // c changed
				uqnInput = uqnJoin([t,i,a1,b,c1,s]);
				uqn.set(uqnInput);
			}
			if (i!=4){ // non-complete square controlled by aSlide, bSlide
				if (a1 != a){ // a changed
					uqnInput = uqnJoin([t,i,a1,b,c,s]);
					uqn.set(uqnInput);
				} else if (i <4 && b1 != b){ // b changed
					uqnInput = uqnJoin([t,i,a,b1,c,s]);
					uqn.set(uqnInput);
				}
			}
		} else if (t==2){
			if (c1 != c){ // c changed
				uqnInput = uqnJoin([t,i,a1,b,c1,s]);
				uqn.set(uqnInput);
			}
			if (i==0 || i==3 || i==4 || i==6){ // controlled by positive sliders
				if (a1 != a){ // a changed
					uqnInput = uqnJoin([t,i,a1,b,c,s]);
					uqn.set(uqnInput);
				} else if (i < 5 && b1 != b){ // b changed
					uqnInput = uqnJoin([t,i,a,b1,c,s]);
					uqn.set(uqnInput);
				}
			}
		}
	}

	function updateSliderNeg(a1:number,b1:number,c1:number){
		let [t,i,a,b,c,s] = uqnSplit($uqn);
		if (t==1){
			if (i==4){ // only complete square controlled by aSlideNeg, bSlideNeg
				[a,b] = signAssign(s,a,b);
				if (a1 != a){ // a changed
					if (4*b==a1*a1){ // unacceptable case
						if (b==9){
							b -= 1;
						} else{
							b += 1;
							if (b==0){
								b = 1;
							}
						}
						bSlideNeg = b;
					}
					let s1 = signUnassign([a1,b]);
					uqnInput = uqnJoin([t,i,Math.abs(a1),Math.abs(b),c,s1]);
					uqn.set(uqnInput);
				} else if (b1 != b){ // b changed
					if (4*b1==a*a){ // unacceptable case
						if (a==9){
							a -= 1;
						} else{
							a += 1;
							if (a==0){
								a = 1;
							}
						}
						aSlideNeg = a;
					}
					let s1 = signUnassign([a,b1]);
					uqnInput = uqnJoin([t,i,Math.abs(a),Math.abs(b1),c,s1]);
					uqn.set(uqnInput);
				}
			}
		} else if (t==2){
			if (i==1||i==2){
				[a,b] = signAssign(s,a,b);
				if (a1 != a){
					if (a1 < 0 && b < 0){
						b = -b;
						bSlideNeg = b;
					}
					let s1 = signUnassign([a1,b,c]);
					uqnInput = uqnJoin([t,i,Math.abs(a1),Math.abs(b),Math.abs(c),s1]);
					uqn.set(uqnInput);
				} else if (b1 != b){
					if (b1 < 0 && a < 0){
						a = -a;
						aSlideNeg = a;
					}
					let s1 = signUnassign([a,b1,c]);
					uqnInput = uqnJoin([t,i,Math.abs(a),Math.abs(b1),Math.abs(c),s1]);
					uqn.set(uqnInput);
				}
			} else if (i==5){
				[a,b] = signAssign(s,a,b);
				if (a1 != a){
					if (4*b==a1*a1){ // unacceptable case
						if (b==9){
							b -= 1;
						} else{
							b += 1;
							if (b==0){
								b = 1;
							}
						}
						bSlideNeg = b;
					}
					let s1 = signUnassign([a1,b,c]);
					uqnInput = uqnJoin([t,i,Math.abs(a1),Math.abs(b),Math.abs(c),s1]);
					uqn.set(uqnInput);
				} else if (b1 != b){
					if (4*b1==a*a){ // unacceptable case
						if (a==9){
							a -= 1;
						} else{
							a += 1;
							if (a==0){
								a = 1;
							}
						}
						aSlideNeg = a;
					}
					let s1 = signUnassign([a,b1,c]);
					uqnInput = uqnJoin([t,i,Math.abs(a),Math.abs(b1),Math.abs(c),s1]);
					uqn.set(uqnInput);
				}
			}
		} else{
			[a,b,c] = signAssign(s,a,b,c);
			if (a1 != a){
				let s1 = signUnassign([a1,b,c]);
				uqnInput = uqnJoin([t,i,Math.abs(a1),Math.abs(b),Math.abs(c),s1]);
				uqn.set(uqnInput);
			} else if (b1 != b){
				let s1 = signUnassign([a,b1,c]);
				uqnInput = uqnJoin([t,i,Math.abs(a),Math.abs(b1),Math.abs(c),s1]);
				uqn.set(uqnInput);
			} else if (c1 != c){
				let s1 = signUnassign([a,b,c1]);
				uqnInput = uqnJoin([t,i,Math.abs(a),Math.abs(b),Math.abs(c1),s1]);
				uqn.set(uqnInput);
			}
		}
	}

	function uqnClick(){
		if (check(uqnInput)){
			uqn.set(uqnInput)
		} else{
			simpleDialog.open();
		}
	}	

</script>

<h2>Options</h2>
<hr>
<h3>UQN</h3>
<p>
	Retrieve a question by keying in a 6 digit UQN :
</p>
<Textfield class="shaped-outlined" variant="outlined" bind:value={uqnInput} label="UQN" type="number"/>
<Button on:click={uqnClick} variant="unelevated" class="button-shaped-round">
	<Label>Generate question</Label>
</Button>
<hr>
<h3>
	Question construction tools
</h3>
<p>First choose the general form of the question:</p>
<RadioGroup bind:radio={type} options={options}/>
<hr>
<p>
	Next choose
	{#if type=="1" || type=="3"}
		<Katex math={"f(x)"}/>:
	{:else}
		<Katex math={"f(y)"}/>:
	{/if}
</p>
{#if type=="1"}
	<RadioGroup bind:radio={intType} options={options1}/>
{:else if type=="2"}
	<RadioGroup bind:radio={intType} options={options2}/>
{:else}
	<RadioGroup bind:radio={intType} options={options3}/>
{/if}
<hr>
<QnPreview uqn={$uqn}/>
<hr>
<p>
	Use the sliders belows to choose different options to craft your own unique question:
</p>
{#if type=="1"}
	{#if intType == "4"}
		<SliderNonZero bind:aSlide={aSlideNeg}/>
		<SliderNonZero bind:aSlide={bSlideNeg} aString="b"/>
	{:else}
	<div>
		<FormField align="end" style="display: flex; width: 90%" >
			<Slider bind:value={aSlide} min={1} max={9} step={1} style="width:80%" discrete displayMarkers/>
			<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"a="+aSlide.toString()}/></span>
		</FormField>
	</div>
		{#if intType!="5" && intType != "6"}
			<div>
				<FormField align="end" style="display: flex; width: 90%" >
					<Slider bind:value={bSlide} min={1} max={9} step={1} style="width:80%" discrete displayMarkers/>
					<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"b="+bSlide.toString()}/></span>
				</FormField>
			</div>
		{/if}
	{/if}
{:else if type=="2"}
	{#if intType=="0" || intType=="3" || intType=="4" || intType=="6"}
		<div>
			<FormField align="end" style="display: flex; width: 90%" >
				<Slider bind:value={aSlide} min={1} max={9} step={1} style="width:80%" discrete displayMarkers/>
				<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"a="+aSlide.toString()}/></span>
			</FormField>
		</div>
		{#if intType!="6"}
			<div>
			<FormField align="end" style="display: flex; width: 90%" >
				<Slider bind:value={bSlide} min={1} max={9} step={1} style="width:80%" discrete displayMarkers/>
				<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"b="+bSlide.toString()}/></span>
			</FormField>
			</div>
		{/if}
	{:else}
		<SliderNonZero bind:aSlide={aSlideNeg}/>
		<SliderNonZero bind:aSlide={bSlideNeg} aString="b"/>
	{/if}
{:else}
	<SliderNonZero bind:aSlide={aSlideNeg}/>
	{#if intType=="1"}
		<SliderNonZero bind:aSlide={bSlideNeg} aString="b"/>
	{/if}
{/if}
<p>
	The sliders below change the 
	{#if type=="3"}
		constants
	{:else}
		constant
	{/if}
	of integration:
</p>
{#if type=="1" || type=="2"}
<div>
	<FormField align="end" style="display: flex; width: 90%" >
		<Slider bind:value={cSlide} min={1} max={9} step={1} style="width:80%" discrete displayMarkers hidden="hidden"/>
		<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"c="+cSlide.toString()}/></span>
	</FormField>
</div>
{:else}
	{#if intType!="1"}
		<SliderNonZero bind:aSlide={bSlideNeg} aString="b"/>
	{/if}
<SliderNonZero bind:aSlide={cSlideNeg} aString="c"/>
{/if}


<Dialog bind:this={simpleDialog}>
	<!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
	<Title>Invalid UQN</Title>
	<Content>
		You have keyed an invalid UQN. Please try again.
	</Content>
	<Actions>
		<Button>
			<Label>OK</Label>
		</Button>
	</Actions>
</Dialog>
<hr>